import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ConfigService} from "../config/config.service";
import { ProCampo } from "../types/ProCampo.type";

@Injectable({
  providedIn: 'root'
})
export class ProcampoService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getCampos() {
    return this.httpClient.get<ProCampo[]>(`${this.configService.getApiUrlRoot()}/proanalise/campos`);
  }

  putCampo(campo: any){
    return this.httpClient.put(`${this.configService.getApiUrlRoot()}/proanalise/campos`, campo)
  }

  postCampo(campo: any){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/proanalise/campos`, campo)
  }

  deletecampo(campo: string){
    return this.httpClient.delete(`${this.configService.getApiUrlRoot()}/proanalise/campos/${campo}`);
  }

  existeCampoDataAtivo(){
    return this.httpClient.get(`${this.configService.getApiUrlRoot()}/proanalise/campos/existe-data-ativa`);
  }

  ativarCampoData(campo: string){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/proanalise/campos/ativar-data/${campo}`, "");
  }

}
